import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from 'src/app/shared/services/firebase.service';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

interface pregunta {
  imagen: string,
  opciones: opcion[],
  pregunta: string,
}

interface opcion {
  numero: number,
  texto: string,
}

@Component({
  selector: 'app-cuestionario',
  templateUrl: './cuestionario.component.html',
  styleUrls: ['./cuestionario.component.css']
})
export class CuestionarioComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fS: FirebaseService,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    public afAuth: AngularFireAuth,
    private shared: RoutingVariablesService,
    private functions: AngularFireFunctions,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  cuestionario: pregunta[];
  respuestas = [];
  notas: any = [];
  imagenes: string[] = []
  presentacionResultados: any[] = [];
  notaFinal: number = 0;
  puedePresentar = false;
  completado = false;
  loaded = 0;
  usuario = JSON.parse(localStorage.getItem('user'));
  ngOnInit(): void {
    this.validar()
  }

  // Validar

  validar() {
    this.afs.collection('usuariosProgresos').ref
      .where("usuarioId", "==", this.usuario.uid)
      .where("cursoId", "==", this.id).get().then((response) => {
        const data = response.docs[0].data();
        if (data['ultimoIntento'] != "") {
          const ult = data['ultimoIntento']
          const now = Date.now() / 1000
          if ((now - ult) < 1) {
            alert('Debe esperar 8 horas entre intentos para presentar el examen')
          } else {
            this.cargarExamen();
          }
        } else {
          this.cargarExamen();
        }
      })
  }

  ///// Metodos de Carga del Examen

  async cargarExamen() {
    this.functions.httpsCallable("cargarExamen")({
      cursoId: this.id,
    }).toPromise().then((cuestionario) => {
      this.cuestionario = cuestionario;
      console.log(this.cuestionario)
      for (let index = 0; index < this.cuestionario.length; index++) {
        this.imagenes = this.imagenes.concat(this.cuestionario[index].imagen)
        this.respuestas.push([])
      }

      console.log(this.imagenes);
      this.loaded = 1;
    }).catch((error) => {
      console.log(error)
    });

  }

  ///// Elementos del cuestionario

  onCheckChange(pregIndex: number, event) {
    // Seleccionado
    if (event.target.checked) {
      this.respuestas[pregIndex] = this.respuestas[pregIndex].concat(+event.target.value)
      this.respuestas[pregIndex].sort((a, b) => a - b);
    }
    // Unselected
    else {
      const index = this.respuestas[pregIndex].indexOf(+event.target.value)
      if (index > -1)
        this.respuestas[pregIndex].splice(index, 1);
      this.respuestas[pregIndex].sort((a, b) => a - b)
    }
    const respuestasContestadas = this.respuestas.filter(x => x.length > 0)

    if (respuestasContestadas.length == this.cuestionario.length) {
      this.completado = true
    }
    else {
      this.completado = false
    }
  }

  async evaluar() {
    this.notaFinal = 0;
    this.presentacionResultados = [];
    this.notas = [];
    let verificacion = [];
    let nota = 0; 
    if (isPlatformBrowser(this.platformId)){
      window.scrollTo(0, 0);
    }
    this.functions.httpsCallable("respuestasCorrectas")({
      cursoId: this.id
    }).toPromise().then((respuestasCorrectas) => {
      console.log("respuestasCorrectas");
      console.log(respuestasCorrectas)
      console.log("respuestas");
      console.log(this.respuestas);
      for (let index = 0; index < this.respuestas.length; index++) {
        let result;
        let notaPreg = 0;
        for (let optIndex = 0; optIndex < this.respuestas[index].length; optIndex++) {
          if (respuestasCorrectas[index][0].includes(this.respuestas[index][optIndex])) {
            nota += 1;
          }
        }
        notaPreg = nota / respuestasCorrectas[index][0].length;
        if (notaPreg == 1 && this.respuestas[index].length == respuestasCorrectas[index][0].length) {
          notaPreg = 1
        } else {
          notaPreg = 0
        }
        this.notaFinal += notaPreg;
        let opciones = [];
        let verificacionOpciones = [];
        for (let optIndex = 0; optIndex < this.cuestionario[index].opciones.length; optIndex++) {
          opciones = opciones.concat(this.cuestionario[index].opciones[optIndex].texto)
          if (respuestasCorrectas[index][0].includes(+optIndex) && this.respuestas[index].includes(+optIndex)) {
            verificacionOpciones.push(2)
          } else if (this.respuestas[index].includes(+optIndex)) {
            verificacionOpciones.push(1)
          } else {
            verificacionOpciones.push(0)
          }
        }
        verificacion = verificacion.concat({
          opciones: verificacionOpciones
        });
        result = {
          'pregunta': this.cuestionario[index].pregunta,
          'opciones': opciones,
          'respuestas': this.respuestas[index],
          'correctas': respuestasCorrectas[index][0],
        }
        this.notas.push(notaPreg);
        this.presentacionResultados = this.presentacionResultados.concat(result)
        nota = 0;
        notaPreg = 0;
      }
      this.notaFinal = this.notaFinal * 100 / this.notas.length;
      console.log(this.notaFinal + '%')
      console.log('notas: ' + this.notas);
      console.log(this.presentacionResultados)
      this.functions.httpsCallable("evaluarExamen")({
        cursoId: this.id,
        puntaje: this.notaFinal,
        ultimoIntento: new Date(),
      }).toPromise().then(() => {
        const obj = {
          nota: this.notaFinal,
          presentacionResultados: this.presentacionResultados,
          cursoId: this.id,
          usuario: this.usuario,
          notas: this.notas,
          verificacion: verificacion,
          imagenes: this.imagenes,
        }
        this.shared.pushResultado(obj)
        this.router.navigate(['/est/resultado-cuestionario'])
      }).catch((error) => {
        console.log(error);
      })
    }).catch((error) => {
      console.log(error);
    })
  }
}
